import { z } from "zod";
import { TASK_BUCKETS } from "@playbookai/types";
/**
 * My Tasks — AI-ranked personal action inbox. `mode` toggles AI grouping vs a
 * flat list; `priorities` filters which buckets show. The bucket vocabulary is
 * reused from `@playbookai/types` (`TASK_BUCKETS`) so it stays a single source
 * of truth. The task rows themselves are a domain read from the mock layer.
 */
export const MyTasksParamsSchema = z
    .object({
    mode: z.enum(["ai", "flat"]).optional(),
    priorities: z.array(z.enum(TASK_BUCKETS)).optional(),
})
    .strict();
export const defaultMyTasksParams = {
    mode: "ai",
    priorities: ["today", "later"],
};
//# sourceMappingURL=myTasks.js.map